import ComparePage from './ComparePage';

export default ComparePage;
